module.exports = __webpack_public_path__ + "media/images/investor-penn-medicine-07719af0.png";